(function () {
    function handleRedirect(event) {
        if (event.origin.indexOf('.marketwatch.com') < 0)
            return;

        if (event.data)
        {
            try {
                var data = JSON.parse(event.data);
                if(data.redirectUrl){
                    window.location = data.redirectUrl;
                }
            } catch (ex) { }
        }      
    };
    
    //lazy load mansion global iframe
    window.addEventListener('lazybeforeunveil', function(e) {
        if (e.target.classList.contains('iframe__container')) {
            var i = document.createElement('iframe');
            i.src = MarketWatch.Settings.endpoints.siteroot + '/personal-finance/real-estate/skybox?embed=1';
            i.setAttribute("id", "js-mg-iframe");
            i.style.cssText = 'width:100%;height:600px;'
            i.setAttribute('frameborder', 0);
            e.target.appendChild(i);
        }
    });

    if (window.addEventListener) {
        window.addEventListener('message', handleRedirect, false);
    }
})(); 